import ActionColumnComponent from "../../components/ActionColumn/ActionColumn";

export const communicationColumns = (viewModal, updateModal, deleteRecord) => {
  const actionColumn = ActionColumnComponent({ viewModal, updateModal, deleteRecord });

  return {
    "Out-of-state Contact Person": [
      { title: "Name", dataIndex: "Name", key: "name" },
      { title: "Phone Number", dataIndex: "Phone Number", key: "phonenumber" },
      { title: "Location", dataIndex: "Location", key: "location" },
      actionColumn,
    ],
    "Social Media Accounts": [
      { title: "Name", dataIndex: "Name", key: "name" },
      { title: "Who's Account", dataIndex: "Who's Account", key: "phonenumber" },
      { title: "User ID", dataIndex: "User ID", key: "userid" },
      { title: "Password", dataIndex: "Password", key: "passowrd" },
      actionColumn,
    ],
    "Emergency Alert Subscriptions": [
      {
        title: "Company",
        dataIndex: "Company",
        key: "company",
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phone number",
      },
      {
        title: "Account Number",
        dataIndex: "Account Number",
        key: "account number",
      },
      actionColumn,
    ],
    "Backup Communication Devices": [
      {
        title: "Item",
        dataIndex: "Item",
        key: "item",
      },
      {
        title: "Location",
        dataIndex: "Location",
        key: "location",
      },
      {
        title: "Notes",
        dataIndex: "Notes",
        key: "notes",
      },
      actionColumn,
    ],
  };
};
